import React from "react";
import {
  CalendarOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import { colors, fontSize } from "~/styles/tokens";
import { JourneyWhyExpander } from "./JourneyWhyExpander";

const { Title, Paragraph } = Typography;

interface OpsJourneySectionProps {
  isMobile: boolean;
}

/**
 * Ops — service requests + amenity reservations split panel.
 */
export const OpsJourneySection: React.FC<OpsJourneySectionProps> = ({
  isMobile,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`journey-content${isMobile ? " is-mobile" : ""}`}>
      <Title level={isMobile ? 3 : 2} style={{ marginTop: 0 }}>
        {t("JourneyGuide_Ops_Title")}
      </Title>
      <Paragraph
        className="journey-lead"
        style={{ fontSize: isMobile ? fontSize.body : fontSize.emphasis }}
      >
        {t("JourneyGuide_Ops_Description")}
      </Paragraph>

      <div className={`journey-split${isMobile ? " is-stacked" : ""}`}>
        <article className="journey-split-card">
          <div
            className="journey-split-icon"
            style={{ background: colors.actionPrimary }}
            aria-hidden
          >
            <ToolOutlined />
          </div>
          <div className="journey-split-copy">
            <div className="journey-split-label">
              {t("JourneyGuide_Ops_SR_Label")}
            </div>
            <p className="journey-split-body">{t("JourneyGuide_Ops_SR_Body")}</p>
            <span className="journey-split-meta">
              {t("JourneyGuide_Ops_SR_Meta")}
            </span>
          </div>
        </article>

        <article className="journey-split-card">
          <div
            className="journey-split-icon"
            style={{ background: colors.actionSecondary }}
            aria-hidden
          >
            <CalendarOutlined />
          </div>
          <div className="journey-split-copy">
            <div className="journey-split-label">
              {t("JourneyGuide_Ops_Amenity_Label")}
            </div>
            <p className="journey-split-body">
              {t("JourneyGuide_Ops_Amenity_Body")}
            </p>
            <span className="journey-split-badge">
              {t("JourneyGuide_Ops_Amenity_Badge")}
            </span>
          </div>
        </article>
      </div>

      <JourneyWhyExpander
        summaryKey="JourneyGuide_Ops_Why_Summary"
        detailKey="JourneyGuide_Ops_Why_Detail"
      />
    </div>
  );
};
